import { getFinancialHeadersForDebtSchedule } from '../../../utils/dateUtils';
import { filterFinancialHeadersWithoutClassificationName, isProvisionalHeader } from '../../../store/investor/constants';
import { formatRatioValue } from '../../../utils/utils';
import { OnePagerContext } from './context';
import { OnePagerSectionConfig } from '../editor/dealSummaryEditorInitializer';
import {
    FINANCIAL_RATIO_DAYS_METRIC_KEYS,
    FINANCIAL_RATIO_PROVISIONAL_KEY_MAP,
    FINANCIAL_RATIO_ROWS,
} from '../editor/dealSummaryEditorConstants';
import { Cell, h2, spacer, table, td, text, th, tr, TrRow } from './plateNodes';

export function buildFinancialRatiosSection(ctx: OnePagerContext, section: OnePagerSectionConfig, auditedSuffix: string): any[] | null {
    const { financialRatioData, provisionalFinancialRatioData, companyMetricsLastUpdatedDate } = ctx;

    if (!financialRatioData || !financialRatioData.headers || !financialRatioData.metrics) {
        return null;
    }

    const ratioMetrics = financialRatioData.metrics;
    const FINANCIAL_HEADERS = getFinancialHeadersForDebtSchedule(companyMetricsLastUpdatedDate);

    const headerRow: TrRow = tr((FINANCIAL_HEADERS ?? []).map((header) => th([text(`${header?.name ?? '-'}`)])));

    const dataRows: TrRow[] = [];

    FINANCIAL_RATIO_ROWS?.forEach((ratioRow) => {
        const metricData = ratioMetrics[ratioRow.metricKey];
        if (!metricData) return;

        const isDaysMetric = FINANCIAL_RATIO_DAYS_METRIC_KEYS.has(ratioRow.metricKey);

        const cells: Cell[] = [td([text(ratioRow.label)])];

        FINANCIAL_HEADERS?.filter?.(filterFinancialHeadersWithoutClassificationName)?.forEach((header) => {
            const isProvisionalHeaderValue = isProvisionalHeader(header);
            let cellValue = '-';

            if (isProvisionalHeaderValue) {
                const provisionalKey = FINANCIAL_RATIO_PROVISIONAL_KEY_MAP[ratioRow.metricKey];
                const provisionalValue = provisionalFinancialRatioData?.[provisionalKey];
                if (provisionalKey && provisionalValue != null) {
                    cellValue = formatRatioValue(provisionalValue, metricData?.unit || '', false, isDaysMetric ? 0 : undefined);
                }
            } else {
                const yearValue = metricData?.[header?.key];
                if (yearValue !== null && yearValue !== undefined) {
                    cellValue = formatRatioValue(
                        yearValue,
                        metricData?.unit || '',
                        metricData?.roundOffRequired || false,
                        isDaysMetric ? 0 : undefined,
                    );
                }
            }

            cells.push(td([text(cellValue)]));
        });

        dataRows.push(tr(cells));
    });

    return [h2([text(`${section.label}${auditedSuffix}`)]), table([headerRow, ...dataRows]), spacer()];
}
